var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-unmatched-records',{staticClass:"toggle-unmatched-remotes",attrs:{"unmatched-count":_vm.unmatchedCount(_vm.record),"is-nested":_vm.isNested,"disabled":_vm.loading(_vm.record.id),"resource-type":"remote"},on:{"toggle-unmatched-records":_vm.toggleUnmatchedRemotes}})
}
var staticRenderFns = []

export { render, staticRenderFns }